import React from 'react';
import { Container } from 'react-bootstrap';
import styles from './ClinicMaterials.module.scss';
import DashboardButtonsCard from '../components/DashboardButtonsCard';
import { Breadcrumb, Row, Col } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';

const ClinicMaterials: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container className="center">
      <h2 className={styles["title"]}>Consultório</h2>
      <Row className={styles["row-breadcrumb"]}>
        <Col>
          <Breadcrumb className={styles.breadcrumb}>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/consultorio' }}>Consultório</Breadcrumb.Item>
            <Breadcrumb.Item active>Materiais</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
      <DashboardButtonsCard
        welcomeMessage={`Materiais`}
        buttons={[
          { text: 'Formulários', onClick: () => navigate('/consultorio/formularios') },
          { text: 'Contratos', onClick: () => navigate('/consultorio/contratos') },
          { text: 'Protocolos de Atendimento', onClick: () => navigate('/consultorio/protocolos') },
          { text: 'Blog', onClick: () => navigate('/consultorio/blog-posts') },
        ]}
      />
    </Container>
  );
};

export default ClinicMaterials;
